export interface UpdateReserveSetRequest {
  id: number
  name: string
  nameKana: string
  bibliographies: {
    reserveSetDetailId: number
    bibliographyRealId: number
    rank: number
  }[]
  revision: number
}

export function UpdateReserveSetRequestToJSON(
  value: UpdateReserveSetRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    name: value.name !== '' ? value.name : undefined,
    name_kana: value.nameKana !== '' ? value.nameKana : undefined,
    bibliographies:
      value.bibliographies.length > 0
        ? value.bibliographies.map(bibliography => {
            return {
              reserve_set_detail_id:
                bibliography.reserveSetDetailId !== 0
                  ? bibliography.reserveSetDetailId
                  : undefined,
              bibliography_real_id:
                bibliography.bibliographyRealId !== 0
                  ? bibliography.bibliographyRealId
                  : undefined,
              rank: bibliography.rank !== 0 ? bibliography.rank : undefined
            }
          })
        : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
